import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { ProjectGroupReleasesResponse } from '../../../../../typings/api';

export type FetchReleaseGroupReleasesQuery = {
  page: number;
  count: number;
  search?: string;
};

//  Function for actually fetching the releases.
const fetchReleases = (releaseGroupId: string, query: FetchReleaseGroupReleasesQuery) =>
  get<ProjectGroupReleasesResponse>(`/api/project_group/${releaseGroupId}/releases`, true, query);

//  Function for uniquely identifying this query.
const getQueryKey = (releaseGroupId: string, query: FetchReleaseGroupReleasesQuery) =>
  ['releaseGroups', releaseGroupId, 'releases', query];

/**
 * This is a hook which will fetch a paginated list of releases for
 * a given release group.
 */
const useReleases = (
  releaseGroupId: string,
  page: number,
  count: number,
  search?: string,
) => {
  const query: FetchReleaseGroupReleasesQuery = { page, count, search };
  return useQuery<ProjectGroupReleasesResponse>({
    queryFn: () => fetchReleases(releaseGroupId, query),
    queryKey: getQueryKey(releaseGroupId, query),
  });
};

export default useReleases;
